module.exports = __webpack_public_path__ + "static/media/ArrowBackMovements.dcb2ceb1.svg";